import { ErrorBoundary } from '@/components/error-boundary';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { queryClient } from '@/lib/query-client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import apiFetch from '@wordpress/api-fetch';
import { lazy, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '../../styles/admin.pcss';
import { createRouter } from './router';

export const router = createRouter();

const TanStackReactQueryDevtools =
	process.env.NODE_ENV === 'production'
		? () => null // Render nothing in production
		: lazy(() =>
				// Lazy load in development
				import('@tanstack/react-query-devtools').then((res) => ({
					default: res.ReactQueryDevtools,
				})),
			);

const TanStackRouterDevtools =
	process.env.NODE_ENV === 'production'
		? () => null // Render nothing in production
		: lazy(() =>
				// Lazy load in development
				import('@tanstack/react-router-devtools').then((res) => ({
					default: res.TanStackRouterDevtools,
					// For Embedded Mode
					// default: res.TanStackRouterDevtoolsPanel
				})),
			);

document.addEventListener('DOMContentLoaded', () => {
	apiFetch.use(apiFetch.createNonceMiddleware(__ALLCOACH_ADMIN__.nonce));
	const rootElement = document.getElementById('AllCoach-Admin-Root');
	if (!rootElement) {
		console.warn('AllCoach Admin: Root element not found');
		return;
	}
	const root = createRoot(rootElement);
	root.render(
		<StrictMode>
			<ErrorBoundary>
				<QueryClientProvider client={queryClient}>
					<TooltipProvider>
						<RouterProvider router={router} />
						<Toaster />
					</TooltipProvider>
					<TanStackRouterDevtools router={router} />
					<TanStackReactQueryDevtools initialIsOpen={false} />
				</QueryClientProvider>
			</ErrorBoundary>
		</StrictMode>,
	);
});
